__turbopack_context__.v({
  "backButton": "ForgotPassword-module___AOzvW__backButton",
  "errorMsg": "ForgotPassword-module___AOzvW__errorMsg",
  "forgotHeader": "ForgotPassword-module___AOzvW__forgotHeader",
  "heading": "ForgotPassword-module___AOzvW__heading",
  "input": "ForgotPassword-module___AOzvW__input",
  "label": "ForgotPassword-module___AOzvW__label",
  "loginBox": "ForgotPassword-module___AOzvW__loginBox",
  "pageWrapper": "ForgotPassword-module___AOzvW__pageWrapper",
  "subText": "ForgotPassword-module___AOzvW__subText",
  "submitBtn": "ForgotPassword-module___AOzvW__submitBtn",
  "successBox": "ForgotPassword-module___AOzvW__successBox",
});
